"use client";

import React from "react";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const fallbackColumns = [{
  title: "Platform",
  links: [{
    label: "Managed Tenant",
    href: "#"
  }, {
    label: "Policy Controls",
    href: "#"
  }, {
    label: "Workspace",
    href: "#"
  }, {
    label: "OceanClaw Control",
    href: "#"
  }, {
    label: "AI Gateway",
    href: "#"
  }]
}, {
  title: "Checkout",
  links: [{
    label: "Apple Pay Integration",
    href: "#"
  }, {
    label: "WordPress Pay",
    href: "#"
  }, {
    label: "Private Threads",
    href: "#"
  }]
}];
const communityLinks = [{
  label: "Documentation",
  href: "#"
}, {
  label: "Security Audit",
  href: "#"
}, {
  label: "System Status",
  href: "#"
}];
const socials = [{
  icon: Twitter,
  href: "#",
  label: "X"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "#",
  label: "LinkedIn"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="222901" className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-12">
        <div className="flex flex-col gap-6 animate-pulse">
          <div className="h-6 w-24 bg-muted rounded" />
          <div className="flex flex-col gap-3">
            {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-32 bg-muted rounded" />)}
          </div>
        </div>
        <div className="flex flex-col gap-6 animate-pulse">
          <div className="h-6 w-24 bg-muted rounded" />
          <div className="flex flex-col gap-3">
            {[1, 2, 3].map(i => <div key={i} data-index={i} className="h-4 w-32 bg-muted rounded" />)}
          </div>
        </div>
      </div>;
  }
  const displayColumns = menuItems && menuItems.length > 0 ? menuItems.slice(0, 2) : fallbackColumns;
  return <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-12">
      {displayColumns.map((col: any, i: number) => <div key={col.id || col.title} data-index={i} className="flex flex-col gap-6">
          <h3 className="font-default text-lg font-semibold text-foreground tracking-tight">
            {col.label || col.title}
          </h3>
          <ul className="flex flex-col gap-3">
            {(col.children || col.links)?.map((link: any, j: number) => <li key={link.id || link.label} data-index={j}>
                <Link to={link.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-sans">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>)}
    </div>;
}
export default function VoltFooter() {
  return <section id="footer" className="bg-background text-foreground py-16 px-4 md:px-8 border-t border-border/20">
      <div className="max-w-7xl mx-auto flex flex-col gap-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636402/img/volt_logo_footer.png" alt="OceanWallet" className="h-7 w-auto opacity-50 grayscale brightness-200" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed font-sans font-medium">
              OceanWallet is a premium AI commerce gateway and next-generation crypto wallet. We provide tenant-based managed experiences with secure identity and policy controls through the OceanClaw control plane.
            </p>
          </div>

          {}
          <MenuProvider menu_id="footer_menu">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-semibold text-foreground tracking-tight">Resources</h3>
            <ul className="flex flex-col gap-3">
              {communityLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.href} className="text-muted-foreground hover:text-primary transition-colors text-sm font-sans">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
            <div className="flex items-center gap-4 mt-2">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} className="text-muted-foreground hover:text-primary transition-colors" aria-label={social.label}>
                    <Icon className="size-5" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="flex flex-col gap-6">
          <Separator className="bg-border/20" />
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-sans font-medium text-muted-foreground">
            <p>© {new Date().getFullYear()} OceanWallet. Built for Coastal Intelligence.</p>
            <div className="flex items-center gap-4">
              <Link to="#" className="hover:text-foreground transition-colors">
                Privacy Policy
              </Link>
              <Separator orientation="vertical" className="h-3 bg-border/20" />
              <Link to="#" className="hover:text-foreground transition-colors">
                Terms of Service
              </Link>
              <Separator orientation="vertical" className="h-3 bg-border/20" />
              <Link to="#" className="hover:text-foreground transition-colors">
                Documentation
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}